import { render, staticRenderFns } from "./KentIDCard.vue?vue&type=template&id=1f1cef9a&scoped=true&"
import script from "./KentIDCard.vue?vue&type=script&lang=js&"
export * from "./KentIDCard.vue?vue&type=script&lang=js&"
import style0 from "./KentIDCard.vue?vue&type=style&index=0&id=1f1cef9a&lang=scss&scoped=true&"
import style1 from "./KentIDCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1cef9a",
  null
  
)

export default component.exports